import { render } from "./PR27-05182023.vue?vue&type=template&id=79fb2c98"
import script from "./PR27-05182023.vue?vue&type=script&lang=js"
export * from "./PR27-05182023.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__